export default __webpack_public_path__ + "static/media/preloader.2918b685.svg";